import { gql } from '../../../../__generated__/graphql/catalog'

export const ORG_ASSOCIATION_QUERY = gql(`
  query OrganizationAssociations($withPortalAssociation: Boolean!, $withOrganizationAssociation: Boolean!) {
    my {
      id
      profile {
        id
        stipend
        stipendCad
      }
      portal @include(if: $withPortalAssociation) {
        id
        collectionHandle
        collectionHeroSectionCG {
          backgroundColor
          ctaText
          id
          imageDesktop
          imageMobile
          imagePlacement
          inlineVideoDesktop
          inlineVideoMobile
          inlineVimeoIdDesktop
          inlineVimeoIdMobile
          subtitle
          textColor
          title
          videoId
          videoPlatform
        }
        promoBarPages {
          id
          content
        }
        embroidery {
          image
          addText
          yesText
          noText
          logoName
          mandatoryTextEmbroideryCategories
          mandatoryLogoEmbroideryCategories
          defaultTextEmbroideryValues {
            textColor
            font
            textPlacement
          }
          textEmbroiderySecondLineOptions
          hiddenTextEmbroideryFields
        }
        name
        discountPercentage
        pdpCtaText
      }
      activeTeamStore @include(if: $withOrganizationAssociation) {
        ...TeamStoreMinimalFields
        ...TeamStoreEmbroideryConstraintFields
        ...TeamStoreCollectionIdentityFields
        ...TeamStoreDiscountPercentageFields
        organization {
          ...OrganizationMinimalFields
        }
      }
    }
    teamStoreAllowedEmbroideryPlacements @include(if: $withOrganizationAssociation) {
      ...TeamStoreAllowedPlacements
    }
  }
`)
